module nucleus.dashboard {
    'use strict';

    export class OverviewVideoController {
        public video = {
            url: ''
        };

        static $inject = [
            '$cookies'
        ];
        constructor($cookies: any) {
            let videoLink = '';
            let  bMLanguageCode = $cookies.get('BMLanguageCode');
            switch (bMLanguageCode) {
            case 'pt-BR': videoLink = '/ua/help/-videos/br-pt/staff/core/onvio-preview-pt.mp4';
                break;
            default: videoLink = '/ua/help/-videos/en/staff/core/onvio-preview.mp4';
            }
            this.video = {
                url: videoLink
            };
        }
    }
    export class OverviewVideoComponent implements ng.IComponentOptions {
        controller = OverviewVideoController;
        templateUrl = 'dashboard/onvio-overview-video/onvio-overview-video.2js.html';
    }
    angular.module('nucleus.dashboard.bmOverviewWidget', [])
    .component('bmOverviewWidget', new OverviewVideoComponent());
}
